/* eslint-disable max-lines */
// Custom Messages
export const enCustomMessages = {
    // navigation
    'navbar.company': 'Company',
    'navbar.language.en': 'English',
    'navbar.language.ro': 'Romanian',
    'navbar.logout': 'Logout',

    // menu
    'menu.label.home': 'Home',
    'menu.label.cf-document': 'CF-Document',

    // login page
    'login.fieldUsername': 'Enter Username',
    'login.fieldPassword': 'Enter Password',
    'login.loginBtn': 'Login',
    'login.clear': 'Reset',
    'login.textLoading': 'Loading...',
    'login.errorUsername': 'Username is required',
    'login.errorPassword': 'Password is required',
    'login.tokenExpiredOrInvalid': 'Token expired or invalid. Please login again.',
    'login.loginError': 'Log in error.',

    // home page
    'home.cardInvoice.title': 'CloudFlow4Invoice',
    'home.cardInvoice.paragraph-1': 'Smart electronic invoicing system',
    'home.cardInvoice.bullet-1': 'Issuance of different eInvoice (invoice, self-invoicing, correction)',
    'home.cardInvoice.bullet-2': 'Export and printing of eInvoices',
    'home.cardInvoice.link': 'Navigate to CloudFlow4Invoice',
    'home.cardTransport.title': 'CloudFlow4Trans',
    'home.cardTransport.paragraph-1': 'Intelligent platform for the management of eCMR document in the transport industry',
    'home.cardTransport.bullet-1': 'Issuance of eCMR document',
    'home.cardTransport.bullet-2': 'Modification and addition of events to the eCMR',
    'home.cardTransport.bullet-3': 'Transparent monitoring and notification of participants to eCMR documents',
    'home.cardTransport.link': 'Navigate to CloudFlow4Trans',

    // cf-document page
    'cf-document.label.title': 'View CF Document',
    'cf-document.control.module': 'Module',
    'cf-document.control.documentNumber': 'Document number',
    'cf-document.control.companyId': 'Company id',
    'cf-document.button.search': 'Search',
    'cf-document.button.map': 'Map',
    'cf-document.button.blockchain': 'Blockchain',
    'cf-document.button.download-pdf': 'Download',
    'cf-document.grid.document-info-section': 'Document info',
    'cf-document.grid.document-sections': 'Signature sections',
    'cf-document.grid.available-actions-section': 'Available actions',
    'cf-document.expansion-panel.fine-registration': 'Fine registration',
    'cf-document.expansion-panel.sign': 'Sign',
    'cf-document.label.id': 'CloudFlow Id',
    'cf-document.label.externalId': 'External Id',
    'cf-document.label.documentType': 'Document type',
    'cf-document.label.documentNumber': 'Document number',
    'cf-document.label.companyId': 'Company Id',
    'cf-document.label.documentState': 'Document state',
    'cf-document.label.publishDate': 'Publish date',
    'cf-document.label.publisherEmail': 'Publisher email',
    'cf-document.label.documentHash': 'Document hash',
    'cf-document.label.contractAddress': 'Contract address',
    'cf-document.label.webhookUrl': 'Webhook url',
    'cf-document.notification.documentFound': 'Document found!',
    'cf-document.notification.documentNotLoaded':
        'Please select the module and write down document number and company id, then press "Search" button!',
    'cf-document.notification.documentError': 'Cannot find any document that matches the given filter!',
    'cf-document.tab.files.title': 'Document versions',
    'cf-document.tab.attachments.title': 'Attachments',
    'cf-document.tab.events.title': 'Events',
    'cf-document.tab.files.column.version': 'Version',
    'cf-document.tab.files.column.fileName': 'File name',
    'cf-document.tab.files.column.extension': 'File extension',
    'cf-document.tab.files.column.downloadSuccess': 'File(s) downloaded successfully',
    'cf-document.tab.files.column.downloadError': 'Error downloading file(s)!',
    'cf-document.tab.events.column.title': 'Title',
    'cf-document.tab.events.column.type': 'Event type',
    'cf-document.tab.events.column.hasAttachment': 'Has attachment?',
    'cf-document.tab.events.column.mention': 'Mention',
    'cf-document.tab.events.column.section': 'Applied on section',
    'cf-document.tab.events.column.documentHash': 'Document hash',
    'cf-document.tab.events.column.blockchainStatus': 'Blockchain status',

    // cf-signature
    'cf-signature.control.section': 'Section',
    'cf-signature.control.signatureType': 'Sign mode',
    'cf-signature.control.signer': 'Signer',
    'cf-signature.button.initiateSign': 'Initiate sign',
    'cf-signature.dialog.signWithPin.title': 'Sign with pin',
    'cf-signature.dialog.signWithPin.column.pin': 'PIN',
    'cf-signature.dialog.signWithPinPatternRequired': 'The input value must be 4 numbers',
    'cf-signature.dialog.signOnGlass.title': 'Sign on glass',
    'cf-signature.dialog.signOnGlassRequired': 'It is mandatory to draw a signature',
    'cf-signature.notification.signatureComplete': 'Section signed successfully!',
    'cf-signature.notification.signatureInitError': 'Error initializing signature process!',
    'cf-signature.notification.signatureCompleteError': 'Error signing a section!',

    // cf-event
    'cf-event.notification.copiedTxId': 'Transaction hash copied to clipboard',

    // company-tasks
    'cf-company-tasks.dialog.registerEventDialog.title': 'Register event',
    'cf-company-tasks.dialog.registerEventDialog.label.mention': 'Mention',
    'cf-company-tasks.dialog.registerEventDialog.label.file': 'File',
    'cf-company-tasks.notification.eventRegistered': 'Event registered successfully!',

    // cf document anonymous
    'cf-document-anonymous.label.greeting': 'Hello',
    'cf-document-anonymous.label.sign-title': 'below you can view and sign the document ...',
    'cf-document-anonymous.label.view-title': 'below you can view the document ...',

    // cf signature anonymous
    'cf-signature-anonymous.label.title': 'Sign CF Document',

    // thanks for signing
    'thanks-for-signing.label.title': 'Thank You!',
    'thanks-for-signing.label.paragraph-1': 'Your signature has been applied successfully.',
    'thanks-for-signing.label.paragraph-2': 'You can download the latest document version by pressing the following link: ',
    'thanks-for-signing.label.download-document': 'Download document',

    // grid
    'grid.columns.actions': 'Actions',
    'grid.columns.createdAt': 'Created at',
    'grid.columns.createdBy': 'Created by',

    // labels
    'labels.download': 'Download',
    'labels.refresh': 'Refresh',
    'labels.yes': 'Yes',
    'labels.no': 'No',
    'labels.map': 'Map',
    'labels.copyToClipboard': 'Copy to clipboard',
    'labels.save': 'Save',
    'labels.cancel': 'Cancel',
    'labels.sign': 'Sign',

    // form errors
    'input.required.error': 'Mandatory field!',
    'file-select.required.error': 'The file is required'
};

// Kendo Angular Component Messages
export const enComponentMessages = {
    // Grid
    'kendo.grid.groupPanelEmpty': 'Drag a column header and drop it here to group by that column',
    'kendo.grid.noRecords': 'No records available.',
    'kendo.grid.pagerFirstPage': 'Go to the first page',
    'kendo.grid.pagerPreviousPage': 'Go to the previous page',
    'kendo.grid.pagerNextPage': 'Go to the next page',
    'kendo.grid.pagerLastPage': 'Go to the last page',
    'kendo.grid.pagerPage': 'Page',
    'kendo.grid.pagerOf': 'of',
    'kendo.grid.pagerItems': 'items',
    'kendo.grid.pagerItemsPerPage': 'items per page',
    'kendo.grid.pagerPageNumberInputTitle': 'Page Number',
    'kendo.grid.filter': 'Filter',
    'kendo.grid.filterEqOperator': 'Is equal to',
    'kendo.grid.filterNotEqOperator': 'Is not equal to',
    'kendo.grid.filterIsNullOperator': 'Is null',
    'kendo.grid.filterIsNotNullOperator': 'Is not null',
    'kendo.grid.filterIsEmptyOperator': 'Is empty',
    'kendo.grid.filterIsNotEmptyOperator': 'Is not empty',
    'kendo.grid.filterStartsWithOperator': 'Starts with',
    'kendo.grid.filterContainsOperator': 'Contains',
    'kendo.grid.filterNotContainsOperator': 'Does not contain',
    'kendo.grid.filterEndsWithOperator': 'Ends with',
    'kendo.grid.filterGteOperator': 'Is greater than or equal to',
    'kendo.grid.filterGtOperator': 'Is greater than',
    'kendo.grid.filterLteOperator': 'Is less than or equal to',
    'kendo.grid.filterLtOperator': 'Is less than',
    'kendo.grid.filterIsTrue': 'is true',
    'kendo.grid.filterIsFalse': 'is false',
    'kendo.grid.filterBooleanAll': '(All)',
    'kendo.grid.filterAfterOrEqualOperator': 'Is after or equal to',
    'kendo.grid.filterAfterOperator': 'Is after',
    'kendo.grid.filterBeforeOperator': 'Is before',
    'kendo.grid.filterBeforeOrEqualOperator': 'Is before or equal to',
    'kendo.grid.filterFilterButton': 'Filter',
    'kendo.grid.filterClearButton': 'Clear',
    'kendo.grid.filterAndLogic': 'And',
    'kendo.grid.filterOrLogic': 'Or',
    'kendo.grid.filterDateToggle': 'Toggle calendar',
    'kendo.grid.filterDateToday': 'Today',
    'kendo.grid.filterNumericDecrement': 'Decrease value',
    'kendo.grid.filterNumericIncrement': 'Increase value',
    'kendo.grid.loading': 'Loading',
    'kendo.grid.sort': 'Sort',
    'kendo.grid.columnMenu': 'Column Menu',
    'kendo.grid.columns': 'Columns',
    'kendo.grid.lock': 'Lock',
    'kendo.grid.unlock': 'Unlock',
    'kendo.grid.stick': 'Stick',
    'kendo.grid.unstick': 'Unstick',
    'kendo.grid.setColumnPosition': 'Set Column Position',
    'kendo.grid.sortAscending': 'Sort Ascending',
    'kendo.grid.sortDescending': 'Sort Descending',
    'kendo.grid.columnsApply': 'Apply',
    'kendo.grid.columnsReset': 'Reset',
    'kendo.grid.sortable': 'Sortable',
    'kendo.grid.sortedAscending': 'Sorted ascending',
    'kendo.grid.sortedDescending': 'Sorted descending',
    'kendo.grid.sortedDefault': 'Not sorted',

    // DropDowns
    'kendo.autocomplete.noDataText': 'No data found',
    'kendo.autocomplete.clearTitle': 'Clear',
    'kendo.combobox.noDataText': 'No data found',
    'kendo.combobox.clearTitle': 'Clear',
    'kendo.dropdownlist.noDataText': 'No data found',
    'kendo.dropdownlist.clearTitle': 'Clear',

    // Calendar
    'kendo.calendar.today': 'TODAY',

    // TextBox
    'kendo.textbox.clearTitle': 'Clear',

    // DatePicker
    'kendo.datepicker.today': 'TODAY',
    'kendo.datepicker.toggle': 'Toggle calendar',

    // DateInput
    'kendo.dateinput.increment': 'Increase value',
    'kendo.dateinput.decrement': 'Decrease value',

    // NumericTextBox
    'kendo.numerictextbox.increment': 'Increase value',
    'kendo.numerictextbox.decrement': 'Decrease value',

    // DateTimePicker
    'kendo.datetimepicker.dateTab': 'Date',
    'kendo.datetimepicker.dateTabLabel': 'Date tab',
    'kendo.datetimepicker.timeTab': 'Time',
    'kendo.datetimepicker.timeTabLabel': 'Time tab',
    'kendo.datetimepicker.toggle': 'Toggle popup',
    'kendo.datetimepicker.accept': 'Set',
    'kendo.datetimepicker.acceptLabel': 'Set',
    'kendo.datetimepicker.cancel': 'Cancel',
    'kendo.datetimepicker.cancelLabel': 'Cancel',
    'kendo.datetimepicker.now': 'NOW',
    'kendo.datetimepicker.nowLabel': 'Select now',
    'kendo.datetimepicker.today': 'TODAY',
    'kendo.datetimepicker.prevButtonTitle': 'Navigate to previous view',
    'kendo.datetimepicker.nextButtonTitle': 'Navigate to next view',

    // TimePicker
    'kendo.timepicker.accept': 'Set',
    'kendo.timepicker.acceptLabel': 'Set',
    'kendo.timepicker.cancel': 'Cancel',
    'kendo.timepicker.cancelLabel': 'Cancel',
    'kendo.timepicker.now': 'Now',
    'kendo.timepicker.nowLabel': 'Now',
    'kendo.timepicker.toggle': 'Toggle time list',

    // FileSelect
    'kendo.fileselect.cancel': 'Cancel',
    'kendo.fileselect.clearSelectedFiles': 'Clear',
    'kendo.fileselect.dropFilesHere': 'Drop files here to upload',
    'kendo.fileselect.externalDropFilesHere': 'Drag and drop files here to upload',
    'kendo.fileselect.filesBatchStatus': 'files',
    'kendo.fileselect.filesBatchStatusFailed': 'files failed to upload.',
    'kendo.fileselect.filesBatchStatusUploaded': 'files successfully uploaded.',
    'kendo.fileselect.fileStatusFailed': 'File failed to upload.',
    'kendo.fileselect.fileStatusUploaded': 'File successfully uploaded.',
    'kendo.fileselect.headerStatusPaused': 'Paused',
    'kendo.fileselect.headerStatusUploaded': 'Done',
    'kendo.fileselect.headerStatusUploading': 'Uploading...',
    'kendo.fileselect.invalidFileExtension': 'File type not allowed.',
    'kendo.fileselect.invalidMaxFileSize': 'File size too large.',
    'kendo.fileselect.invalidMinFileSize': 'File size too small.',
    'kendo.fileselect.remove': 'Remove',
    'kendo.fileselect.retry': 'Retry',
    'kendo.fileselect.select': 'Select files...',
    'kendo.fileselect.uploadSelectedFiles': 'Upload files',

    // Scheduler
    'kendo.scheduler.agendaViewTitle': 'Agenda',
    'kendo.scheduler.allDay': 'all day',
    'kendo.scheduler.allEvents': 'All events',
    'kendo.scheduler.calendarToday': 'TODAY',
    'kendo.scheduler.cancel': 'Cancel',
    'kendo.scheduler.save': 'Save',
    'kendo.scheduler.editorEventTitle': 'Title',
    'kendo.scheduler.editorEventStart': 'Start',
    'kendo.scheduler.editorEventStartTimeZone': 'Start Time Zone',
    'kendo.scheduler.editorEventEnd': 'End',
    'kendo.scheduler.editorEventEndTimeZone': 'End Time Zone',
    'kendo.scheduler.dateHeader': 'Date',
    'kendo.scheduler.dayViewTitle': 'Day',
    'kendo.scheduler.deleteConfirmation': 'Are you sure you want to delete this event?',
    'kendo.scheduler.deleteDialogTitle': 'Delete Event',
    'kendo.scheduler.deleteOccurrence': 'Delete current occurrence',
    'kendo.scheduler.deleteRecurringConfirmation': 'Do you want to delete only this event occurrence or the whole series?',
    'kendo.scheduler.deleteRecurringDialogTitle': 'Delete Recurring Item',
    'kendo.scheduler.deleteSeries': 'Delete the series',
    'kendo.scheduler.deleteTitle': 'Delete',
    'kendo.scheduler.destroy': 'Delete',
    'kendo.scheduler.editOccurrence': 'Edit current occurrence',
    'kendo.scheduler.editorEventAllDay': 'All Day Event',
    'kendo.scheduler.editorEventDescription': 'Description',
    'kendo.scheduler.editorEventSeparateTimeZones': 'End in different Time Zone',
    'kendo.scheduler.editorEventTimeZone': 'Specify Time Zone',
    'kendo.scheduler.editorTitle': 'Event',
    'kendo.scheduler.editRecurringConfirmation': 'Do you want to edit only this event occurrence or the whole series?',
    'kendo.scheduler.editRecurringDialogTitle': 'Edit Recurring Item',
    'kendo.scheduler.editSeries': 'Edit the series',
    'kendo.scheduler.eventHeader': 'Event',
    'kendo.scheduler.monthViewTitle': 'Month',
    'kendo.scheduler.multiDayViewTitle': 'Multi-Day',
    'kendo.scheduler.nextTitle': 'Next',
    'kendo.scheduler.previousTitle': 'Previous',
    'kendo.scheduler.recurrenceEditorDailyInterval': 'day(s)',
    'kendo.scheduler.recurrenceEditorDailyRepeatEvery': 'Repeat every',
    'kendo.scheduler.recurrenceEditorEndAfter': 'After',
    'kendo.scheduler.recurrenceEditorEndLabel': 'End',
    'kendo.scheduler.recurrenceEditorEndNever': 'Never',
    'kendo.scheduler.recurrenceEditorEndOccurrence': 'occurrence(s)',
    'kendo.scheduler.recurrenceEditorEndOn': 'On',
    'kendo.scheduler.recurrenceEditorFrequenciesDaily': 'Daily',
    'kendo.scheduler.recurrenceEditorFrequenciesMonthly': 'Monthly',
    'kendo.scheduler.recurrenceEditorFrequenciesNever': 'Never',
    'kendo.scheduler.recurrenceEditorFrequenciesWeekly': 'Weekly',
    'kendo.scheduler.recurrenceEditorFrequenciesYearly': 'Yearly',
    'kendo.scheduler.recurrenceEditorMonthlyDay': 'Day',
    'kendo.scheduler.recurrenceEditorMonthlyInterval': 'month(s)',
    'kendo.scheduler.recurrenceEditorMonthlyRepeatEvery': 'Repeat every',
    'kendo.scheduler.recurrenceEditorMonthlyRepeatOn': 'Repeat on',
    'kendo.scheduler.recurrenceEditorOffsetPositionsFirst': 'First',
    'kendo.scheduler.recurrenceEditorOffsetPositionsFourth': 'Fourth',
    'kendo.scheduler.recurrenceEditorOffsetPositionsLast': 'Last',
    'kendo.scheduler.recurrenceEditorOffsetPositionsSecond': 'Second',
    'kendo.scheduler.recurrenceEditorOffsetPositionsThird': 'Third',
    'kendo.scheduler.recurrenceEditorRepeat': 'Repeat',
    'kendo.scheduler.recurrenceEditorWeekdaysDay': 'Day',
    'kendo.scheduler.recurrenceEditorWeekdaysWeekday': 'Weekday',
    'kendo.scheduler.recurrenceEditorWeekdaysWeekendday': 'Weekend Day',
    'kendo.scheduler.recurrenceEditorWeeklyInterval': 'week(s)',
    'kendo.scheduler.recurrenceEditorWeeklyRepeatEvery': 'Repeat every',
    'kendo.scheduler.recurrenceEditorWeeklyRepeatOn': 'Repeat on',
    'kendo.scheduler.recurrenceEditorYearlyInterval': 'year(s)',
    'kendo.scheduler.recurrenceEditorYearlyOf': 'of',
    'kendo.scheduler.recurrenceEditorYearlyRepeatEvery': 'Repeat every',
    'kendo.scheduler.recurrenceEditorYearlyRepeatOn': 'Repeat on',
    'kendo.scheduler.showFullDay': 'Show full day',
    'kendo.scheduler.showWorkDay': 'Show business hours',
    'kendo.scheduler.timeHeader': 'Time',
    'kendo.scheduler.timelineMonthViewTitle': 'Timeline Month',
    'kendo.scheduler.timelineViewTitle': 'Timeline',
    'kendo.scheduler.timelineWeekViewTitle': 'Timeline Week',
    'kendo.scheduler.today': 'Today',
    'kendo.scheduler.weekViewTitle': 'Week',
    'kendo.scheduler.workWeekViewTitle': 'Work Week',

    // RecurrenceEditor
    'kendo.recurrenceeditor.dailyInterval': 'day(s)',
    'kendo.recurrenceeditor.dailyRepeatEvery': 'Repeat every',
    'kendo.recurrenceeditor.endAfter': 'After',
    'kendo.recurrenceeditor.endLabel': 'End',
    'kendo.recurrenceeditor.endNever': 'Never',
    'kendo.recurrenceeditor.endOccurrence': 'occurrence(s)',
    'kendo.recurrenceeditor.endOn': 'On',
    'kendo.recurrenceeditor.frequenciesDaily': 'Daily',
    'kendo.recurrenceeditor.frequenciesMonthly': 'Monthly',
    'kendo.recurrenceeditor.frequenciesNever': 'Never',
    'kendo.recurrenceeditor.frequenciesWeekly': 'Weekly',
    'kendo.recurrenceeditor.frequenciesYearly': 'Yearly',
    'kendo.recurrenceeditor.monthlyDay': 'Day',
    'kendo.recurrenceeditor.monthlyInterval': 'month(s)',
    'kendo.recurrenceeditor.monthlyRepeatEvery': 'Repeat every',
    'kendo.recurrenceeditor.monthlyRepeatOn': 'Repeat on',
    'kendo.recurrenceeditor.offsetPositionsFourth': 'Fourth',
    'kendo.recurrenceeditor.offsetPositionsLast': 'Last',
    'kendo.recurrenceeditor.offsetPositionsSecond': 'Second',
    'kendo.recurrenceeditor.offsetPositionsThird': 'Third',
    'kendo.recurrenceeditor.repeat': 'Repeat',
    'kendo.recurrenceeditor.weekdaysDay': 'Day',
    'kendo.recurrenceeditor.weekdaysWeekday': 'Weekday',
    'kendo.recurrenceeditor.weekdaysWeekendday': 'Weekend Day',
    'kendo.recurrenceeditor.weeklyInterval': 'week(s)',
    'kendo.recurrenceeditor.weeklyRepeatEvery': 'Repeat every',
    'kendo.recurrenceeditor.weeklyRepeatOn': 'Repeat on',
    'kendo.recurrenceeditor.yearlyInterval': 'year(s)',
    'kendo.recurrenceeditor.yearlyOf': 'of',
    'kendo.recurrenceeditor.yearlyRepeatEvery': 'Repeat every',
    'kendo.recurrenceeditor.yearlyRepeatOn': 'Repeat on',

    //Filter
    'kendo.filter.addExpression': 'Add Expression',
    'kendo.filter.addFilter': 'Add Filter',
    'kendo.filter.addGroup': 'Add Group',
    'kendo.filter.remove': 'Remove',
    'kendo.filter.editorDateTodayText': 'Today',
    'kendo.filter.editorDateToggleText': 'Toggle calendar',
    'kendo.filter.editorNumericDecrement': 'Decrement',
    'kendo.filter.editorNumericIncrement': 'Increment',
    'kendo.filter.filterAfterOperator': 'Is After',
    'kendo.filter.filterAfterOrEqualOperator': 'Is after or equal to',
    'kendo.filter.filterAndLogic': 'And',
    'kendo.filter.filterBeforeOperator': 'Is before',
    'kendo.filter.filterBeforeOrEqualOperator': 'Is before or equal to',
    'kendo.filter.filterBooleanAll': '(All)',
    'kendo.filter.filterContainsOperator': 'Contains',
    'kendo.filter.filterEndsWithOperator': 'Ends with',
    'kendo.filter.filterEqOperator': 'Is equal to',
    'kendo.filter.filterExpressionFilters': 'Filters',
    'kendo.filter.filterExpressionOperators': 'Operators',
    'kendo.filter.filterGtOperator': 'Is greater than',
    'kendo.filter.filterGteOperator': 'Is greater than or equal to',
    'kendo.filter.filterIsEmptyOperator': 'Is empty',
    'kendo.filter.filterIsFalse': 'Is False',
    'kendo.filter.filterIsTrue': 'Is True',
    'kendo.filter.filterIsNotEmptyOperator': 'Is not empty',
    'kendo.filter.filterIsNotNullOperator': 'Is not null',
    'kendo.filter.filterIsNullOperator': 'Is null',
    'kendo.filter.filterLtOperator': 'Is less than',
    'kendo.filter.filterLteOperator': 'Is less than or equal to',
    'kendo.filter.filterNotContainsOperator': 'Does not contain',
    'kendo.filter.filterNotEqOperator': 'Is not equal to',
    'kendo.filter.filterOrLogic': 'Or',
    'kendo.filter.filterStartsWithOperator': 'Starts with',
    'kendo.filter.filterFieldAriaLabel': 'field',
    'kendo.filter.filterOperatorAriaLabel': 'operator',
    'kendo.filter.filterValueAriaLabel': 'value',
    'kendo.filter.filterAriaLabel': 'filter',
    'kendo.filter.filterToolbarAriaLabel': 'filter settings'
};
